import React from 'react';
import { bem, getDataAttr } from '../_libs/utils';
import CommentText from './CommentText';
import { Component, PropTypes } from '../_libs';

export default class CommentItem2Item extends Component {
  render() {
    const displayName = 'comment';
    const { children, data, itemClick, moreClick, moreExtra } = this.props;
    return (
      <div
        className={this.className(bem(displayName, 'body'), bem(displayName, 'item2item'))}
        {...getDataAttr(this.props)}>{ /* 楼中楼，列表页 */}
        {data.length && data.map((item, index) => <CommentText
          itemClick={(e) => { itemClick && itemClick(e, item); }}
          key={index}
          size="m"
          at={item.at}>
          {item.text}
        </CommentText>)}
        {children}
        <div className="view-more" onClick={moreClick}>{moreExtra}</div>
      </div>
    );
  }
}

CommentItem2Item.defaultProps = {
  children: null,
  data: [],
  itemClick: () => {},
  moreClick: () => {},
  moreExtra: null,
};

CommentItem2Item.propTypes = {
  // @INTRO children
  children: PropTypes.node,
  // @INTRO 楼中楼data
  data: PropTypes.array,
  // @INTRO item点击事件
  itemClick: PropTypes.func,
  // @INTRO 更多回调func
  moreClick: PropTypes.func,
  // @INTRO 更多
  moreExtra: PropTypes.node,
};
